import {useState, useEffect, useRef, useCallback} from "react";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import {Animated} from "react-animated-css";
import CancellationsGrid from "./CancellationsGrid";
import CancellationsForm from "./CancellationsForm";
import CancellationFormEdit from "./CancellationFormEdit";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function Cancellations(props) {

    const {DataStore} = props
    const {companyName, idCompany,} = DataStore

    const [load, setLoad] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [dataEdit, setDataEdit] = useState({})

    const isMounted = useMountedState()

    useEffect(() => {
        const GetCancellations = async () => {
            const newArray = []
            let ID = 0
            await db.collection(companyName).doc(idCompany).collection('cancellation')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            ID = ID + 1
                            const obj = {...doc.data(), docId: doc.id, ID: ID}
                            newArray.push(obj)
                        } else {
                            setDataSource([])
                        }
                    });
                    setDataSource(newArray)
                    setLoad(true)
                })
                .catch(function () {
                    setLoad(true)
                    setDataSource(newArray)
                });
        }
        if (isMounted()) {
            GetCancellations().catch(() => setTrigger(!trigger))
        }
    }, [companyName, idCompany, isMounted, trigger])

    return (
        <>
            {visibleGrid &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <CancellationsGrid load={load} dataSource={dataSource} setEdit={setEdit}
                                   setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                   setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                                   trigger={trigger}/>
            </Animated>}

            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <CancellationsForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                   DataStore={DataStore} setVisibleGrid={setVisibleGrid}/>
            </Animated>
            }

            {edit &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <CancellationFormEdit DataStore={DataStore} setVisibleGrid={setVisibleGrid} setEdit={setEdit}
                                      dataEdit={dataEdit} setTrigger={setTrigger} trigger={trigger}/>
            </Animated>
            }
        </>
    )

}

export default inject('DataStore')(observer(Cancellations));